import { render, staticRenderFns } from "./UserDetailsPortal.vue?vue&type=template&id=473a430a&scoped=true&"
import script from "./UserDetailsPortal.vue?vue&type=script&lang=js&"
export * from "./UserDetailsPortal.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsPortal.vue?vue&type=style&index=0&id=473a430a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a430a",
  null
  
)

export default component.exports